var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoaderWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.9333333333333333s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(24 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.8666666666666667s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(48 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.8s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.7333333333333333s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(96 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.6666666666666666s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.6s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5333333333333333s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(168 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.4666666666666667s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(192 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.4s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(216 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.3333333333333333s",
    repeatCount: "indefinite"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.26666666666666666s",
    repeatCount: "indefinite"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(264 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.2s",
    repeatCount: "indefinite"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(288 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.13333333333333333s",
    repeatCount: "indefinite"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(312 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.06666666666666667s",
    repeatCount: "indefinite"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(336 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 6,
    width: 6,
    height: 12,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderWhite);
export default __webpack_public_path__ + "static/media/loader-white.d75aaa4fece7f722282945e1ef31505a.svg";
export { ForwardRef as ReactComponent };